window.Flock = window.Flock || {};
import 'jquery-mask-plugin';

Flock.Utils = {
  urlParamExist: function (param) {
    var url = window.location.href;
    if (url.indexOf('?' + param + '=') != -1) {
      return true;
    }
    else if (url.indexOf('&' + param + '=') != -1) {
      return true;
    }
    return false
  },
  formatCurrency: function(n,c,d,t){
    if(typeof n == "string" && n.indexOf('$') > -1){
      return n.split("$")[1];
    }
   var c = isNaN(c = Math.abs(c)) ? 2 : c,
       d = d == undefined ? "." : d,
       t = t == undefined ? "," : t,
       s = n < 0 ? "-" : "",
       i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
       j = (j = i.length) > 3 ? j % 3 : 0;
   var result = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
   return (result == 'NaN.N') ? 0 : result
  },
  calculatePerPayPeriod: function(pay_period, amount){
    return this.formatCurrency(amount * 12 / pay_period);
  },
  maskInternationalPhone: function(phone) {
    return /^(?:\+?\d{1,3}\s*-?)?\(?(?:\d{3})?\)?[- ]?\d{3}[- ]?\d{4}?( (x|X) \d{1,5})?$/.test(phone);
  },
  internationalPhoneMask: function() {
    $(".js-int-phone-mask").on("keyup", (e) => {
      var phone = e.target.value;
      var field = e.target.dataset.field;
      var fieldId = e.target.id;
      if(phone.length == 0) {
        $(`#${fieldId}`).unmask();
      } else {
        if (($('.js-personal-country').val() == 'United States') || field.includes("i9") || field.includes("broker")) {
          if(phone.includes("+")) {
            if(fieldId == "personal_info_mob" || fieldId == "personal_info_alter_mob" || fieldId == "emergency_info_mob" || fieldId == "emergency_info_alter_mob" || fieldId == "company_broker_advisor_phone" || fieldId == "company_support_team_phone" || fieldId == "broker_hr_contact_phone") {
              $(`#${fieldId}`).mask("+0 (000) 000-0000 x 0000000");
            } else {
              $(`#${fieldId}`).mask("+0 (000) 000-0000");
            }
          } else {
            if(fieldId == "personal_info_mob" || fieldId == "personal_info_alter_mob" || fieldId == "emergency_info_mob" || fieldId == "emergency_info_alter_mob" || fieldId == "company_broker_advisor_phone" || fieldId == "company_support_team_phone" || fieldId == "broker_hr_contact_phone") {
              $(`#${fieldId}`).mask('(000) 000-0000 x 0000000');
            } else {
              $(`#${fieldId}`).mask('(000) 000-0000');
            }
            e.target.value = phone;
          }
        }
      }
      if(phone.length == 0) {
        $(`.js-${field}-phone-error`).addClass("d-none");
        $(".js-update-btn").removeAttr("disabled");
      } else {
        if(Flock.Utils.maskInternationalPhone(phone)) {
          $(`.js-${field}-phone-error`).addClass("d-none");
          $(".js-update-btn").removeAttr("disabled")
        } else {
          $(`.js-${field}-phone-error`).removeClass("d-none");
          $(".js-update-btn").attr("disabled", true)
        }
      }
      if($(".int-phone-error").is(":visible")) {
        $(".js-update-btn").attr("disabled", true)
      } else {
        $(".js-update-btn").removeAttr("disabled")
      }
    })
  },
  isDefined: function(reference) {
    return !_.isUndefined(reference);
  },
  isNotEmpty: function(obj) {
    return !_.isEmpty(obj)
  },
  isBlankString: function(string) {
    return (_.isUndefined(string) || _.isNull(string) || string.length === 0)
  },
  isPresentString: function(string) {
    return !this.isBlankString(string) && string.length > 0;
  },
  capitalize: function(string) {
    return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
  },
  titleize: function(string) {
    var string_array = string.split(' ');
    string_array = string_array.map(function(string) {
      return Flock.Utils.capitalize(string);
    })
    return string_array.join(' ');
  },
  getQueryParams: function(queryString) {
    var query = (queryString || window.location.search).substring(1); // delete ?
    if (!query) {
      return false;
    }
    return _
    .chain(query.split('&'))
    .map(function(params) {
      var p = params.split('=');
      return [p[0], decodeURIComponent(p[1])];
    })
    .object()
    .value();
  },
  getUrlVars: function(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function(name){
    return this.getUrlVars()[name];
  },
  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  detectIE: function() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
         // Edge (IE 12+) => return version number
         return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
  },

  getDefaultAvatar: function(fullname) {
     var colors = ["#F44336","#E91E63","#9C27B0","#673AB7","#3F51B5","#2196F3","#03A9F4","#00BCD4",
                    "#009688","#4CAF50","#8BC34A","#CDDC39","#FFC107","#FF9800","#FF5722","#795548",
                    "#9E9E9E","#607D8B","#F44336","#E91E63","#9C27B0","#673AB7","#3F51B5","#2196F3",
                    "#03A9F4","#00BCD4","#009688","#4CAF50","#8BC34A","#CDDC39","#FFC107","#FF9800",
                    "#FF5722","#795548","#9E9E9E","#607D8B"
                  ];
    if(fullname) {
      var names = fullname.split(" ");
      var firstname = 'a';
      var lastname = 'a';
      if(names[0])
        firstname = names[0].toLowerCase();
      if(names[1])
        lastname = names[1].toLowerCase();
      var nameVal = ((firstname[0].charCodeAt() - 97)  + (lastname[0].charCodeAt() - 97));
      nameVal = nameVal / 2;
      nameVal = Math.ceil(nameVal);
      var randomColor = colors[nameVal];
      if(!randomColor)
        randomColor = "#777777";
      return randomColor;
    }
  },

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
  },

  updateEmpInfo: function(data, responseMsg){
    $.ajax({
      type: "PUT",
      url: '/api/v1/emp_infos/update_settings',
      data: JSON.stringify(data),
      headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      success: function (response) {
        if(responseMsg){
          var message = new Flock.Views.FlashMessage(responseMsg, 'success');
          message.render();
        }
      },
      error: function (error) {
      }
    });
  },

  fetchAndOpenAttachmentLink(e){
    if(window.ReactNativeWebView){
      e.preventDefault();
      if(e.currentTarget.href.includes(window.location.origin)){
        $.ajax({
          type: "GET",
          url: $(e.currentTarget).attr('href'),
          headers: {
              'Content-Type': 'application/json'
            },
          success: function (response) {
            if(response && response.url){
              window.ReactNativeWebView.postMessage(JSON.stringify({
                                    external_url_open: response.url
                                  }));
            }
          },
          error: function (error) {
          }
        });
      } else {
        this.openExternalUrl(e)
      }
    }
  },

  formatOtelBizpn(bizpn){
    if(bizpn){
      return $('meta[name="user-axit"]').attr('content')+"_"+bizpn
    }
  },

  showToast: function (type, message, options = {}) {
    const defaults = {
      title: type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Notice',
      autoHideDelay: 5000,
      appendToast: true,
      solid: true,
      toaster: 'b-toaster-top-right'
    };

    const toastOptions = { ...defaults, ...options };

    const variantMap = {
      'success': 'success',
      'error': 'danger',
      'danger': 'danger',
      'notice': 'info',
      'info': 'info',
      'warning': 'warning'
    };

    toastOptions.variant = variantMap[type] || 'info';

    const toastHtml = `
    <div class="alert alert--sticky alert-info-icon alert-${type === 'success' ? 'success' : 'danger'} justify-content-between"
         role="alert"
         style="position: fixed; top: 20px; right: 20px; z-index: 9999; min-width: 300px; animation: slideInRight 0.3s ease-out;">
      <div class="alert__body">${message}</div>
      <button type="button" class="btn-close me-2" aria-label="Close" onclick="this.parentElement.remove()">
        
      </button>
    </div>
  `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = toastHtml.trim();
    const toastElement = tempDiv.firstChild;
    document.body.appendChild(toastElement);

    setTimeout(() => {
      if (toastElement && toastElement.parentElement) {
        toastElement.style.animation = 'slideOutRight 0.3s ease-out';
        setTimeout(() => toastElement.remove(), 300);
      }
    }, toastOptions.autoHideDelay);

    return toastElement;
  },

  handleExternalLinksOnMobile(selector){
    if(window.ReactNativeWebView){
      if(!selector){selector = 'a[target="_blank"][href]';}
      var attachEvent = function(elem, event, callback)
      {
          event = event.replace(/^on/g, '');
          if ( 'addEventListener' in window ) {

              elem.addEventListener(event, callback, false);
          } else if ( 'attachEvent' in window ) {
              elem.attachEvent('on'+event, callback);
          } else {
              var registered = elem['on' + event];
              elem['on' + event] = registered ? function(e) {
                  console.log("already has event");
                  registered(e);
                  callback(e);
              } : callback;
          }

          return elem;
      }
      // window.ReactNativeWebView.postMessage("got all links");
      var all_links = document.querySelectorAll(selector);
      // window.ReactNativeWebView.postMessage("got all links");
      if ( all_links ) {
        for ( var i in all_links ) {
          if ( all_links.hasOwnProperty(i) && !all_links[i].classList.contains("js-fetch-open-link") ) {
            attachEvent(all_links[i], 'onclick', function(e){
              // console.log(e)
              if ( new RegExp( '^https?:\/\/', 'gi' ).test( this.href ) ) {
                // handle external URL
                e.preventDefault();
                window.ReactNativeWebView.postMessage(JSON.stringify({
                  external_url_open: this.href,
                }));
              }
            });
          }
        }
      }
    }
  },

  displayNpsSurvey: function(){
    if(Flock.vueComponentList && Flock.vueComponentList.length){
      for (var i = Flock.vueComponentList.length - 1; i >= 0; i--) {
        if(Flock.vueComponentList[i].$el && Flock.vueComponentList[i].$el.id && Flock.vueComponentList[i].$el.id == 'nps-survey-el'){
          if(Flock.vueComponentList[i].$children[0])
            Flock.vueComponentList[i].$children[0].displaySurvey()
        }
      }
    }
  },

  openExternalUrl: function(e){
    if(window.ReactNativeWebView){
      e.preventDefault();
      window.ReactNativeWebView.postMessage(JSON.stringify({
                  external_url_open: e.currentTarget.href,
                }));
    }
  },

  normalizedDate(dateString){
    // the Date constructor defaults to midnight local time, then retrieves
    // dates in UTC, which results in off-by-one errors for American locales
    if(dateString && (dateString.length || (typeof dateString == 'object'))) {
      var tempDate = new Date(dateString);
      // `getTimezoneOffset` returns the offset in minutes, but `new Date`
      // and `getTime` use milliseconds; there are 60000 milliseconds/minute
      return new Date(tempDate.getTime() + moment().utcOffset() * 60000);
    } else {
      return '';
    }
  },

  defaultUserPic: null
  // defaultUserPic: 'data:image/png;base64,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',

};
